import {ariaToggle} from '../globals/aria-toggle';

class CollectionNavigation extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.section;
    this.gridContainer = document.querySelector(`#collection-main-${this.sectionId}`);
    this.navLinks = this.querySelectorAll('.js-collection-nav-link');

    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(e) {
    if (e.target.classList.contains('js-collection-nav-link')) {
      e.preventDefault();

      const url = e.target.getAttribute('href');
      const gridOuter = document.querySelector('.grid-outer');

      if (gridOuter) {
        gridOuter.classList.add('is-loading');
      }

      if (this.gridContainer && this.navLinks) {
        this.navLinks.forEach((link) => {
          link.removeAttribute('aria-current');
          link.classList.add('disabled')
        });
        e.target.setAttribute('aria-current', 'page');
        window.history.pushState({}, '', url);
      }

      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['.js-collection-header', '.js-collection-main'];
          this.navLinks.forEach((link) => link.classList.remove('disabled'));

          selectors.forEach((selector) => {
            const destination = document.querySelector(selector);
            const source = html.querySelector(selector);

            if (!source || !destination) return;
            destination.innerHTML = source.innerHTML;
          })

          if (gridOuter) {
            gridOuter.classList.remove('is-loading');
          }

          ariaToggle(this.gridContainer)
        })
        .catch((error) => {
          console.error('Error loading collection:', error);
        });

    }
  }
}

if (!customElements.get('collection-nav')) {
  customElements.define('collection-nav', CollectionNavigation);
}
